import { Component, Input } from '@angular/core';

@Component({
    selector: 'pkp-validation-message',
    template:
        '<div class="has-error-inline" *ngIf="show"><ng-content></ng-content></div>'
})
/**
 * See https://stackoverflow.com/a/42182602
 */
export class ValidationMessageComponent {
    @Input() name: string;
    @Input() show: boolean = false;

    showsErrorIncludedIn(errors: string[]): boolean {
        return errors.some((error) => error === this.name);
    }
}
